import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { getRoomByVitaRef } from 'src/api/bookingService';
import { Building } from 'src/shared/types/building';
import { Room } from 'src/shared/types/room';

import { queryRetry } from '../query-retry';

export const useFetchRoomByVitaRef = (vitaRef: string, userLoggedIn: boolean) => {
    const hasVitaRef = vitaRef !== null && vitaRef.length > 0;

    const query = useQuery<
        { room: Room; building: Building },
        AxiosError,
        { room: Room; building: Building }
    >({
        enabled: hasVitaRef && userLoggedIn,
        queryKey: ['booking', 'vitaRef', vitaRef],
        queryFn: () => getRoomByVitaRef(vitaRef as string),
        retry: queryRetry,
    });

    return {
        ...query,
    };
};
